import './base_filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters.PublicationsSession'

class Monitoring.Views.SocialContents.Filters.PublicationsSession.PostsFilterView extends Monitoring.Views.SocialContents.Filters.PublicationsSession.BaseFilterView

  template: JST["backbone/templates/monitoring/filters/publications_session/posts_filter"]

  initialize: ({options, filterContainerView, selectedProvider, sortedAvailableChannelsByProvider}) ->
    dashboardResults = options.dashboardResults
    @searchQuery = options.searchQuery
    @facets = dashboardResults.facets
    @postFacets = dashboardResults.post_facets
    @tagsByClientCode = dashboardResults.tags_by_client_code || []
    @sortedAvailableChannelsByProvider = sortedAvailableChannelsByProvider
    @filterContainerView = filterContainerView
    @selectedProvider = selectedProvider

  renderFilters: ->
    @postKeywordFilterView = new Monitoring.Views.SocialContents.Filters.PostKeywordFilterView({ searchQuery: @searchQuery, facet: @facets })
    @$el.find('#post_keyword_filter').html(@postKeywordFilterView.render().el)

    @postDateFilterView = new Monitoring.Views.SocialContents.Filters.PostDateFilterView({ searchQuery: @searchQuery, facet: @facets, filtersContainer: @filterContainerView.filtersContainer() })
    @$el.find('#post_date_filter').html(@postDateFilterView.render().el)

    @postTagsFilterView = new Monitoring.Views.SocialContents.Filters.PostTagsFilterView({ searchQuery: @searchQuery, facet: @postFacets, tagsByClientCode: @tagsByClientCode })
    @$el.find('#post_tag_filter').html(@postTagsFilterView.render().el)

    @postLabelsFilterView = new Monitoring.Views.SocialContents.Filters.PostLabelsFilterView({ searchQuery: @searchQuery, facet: @postFacets })
    @$el.find('#post_label_filter').html(@postLabelsFilterView.render().el)

    @postChannelFilterView = new Monitoring.Views.SocialContents.Filters.PostChannelsFilterView({searchQuery: @searchQuery, sortedAvailableChannelsByProvider: @sortedAvailableChannelsByProvider, selectedProvider: @selectedProvider})
    @$el.find('#post_channel_filter').html(@postChannelFilterView.render().el)

    @postSourceTypeFilterView = new Monitoring.Views.SocialContents.Filters.PostSourceTypeFilterView({ searchQuery: @searchQuery, facet: @postFacets })
    @$el.find('#post_source_type_filter').html(@postSourceTypeFilterView.render().el)

  renderAppliedFilters: ->
    @appliedPosts = new Monitoring.Views.SocialContents.Filters.AppliedPostsView({ searchQuery: @searchQuery })
    @$el.find('#applied_posts').html(@appliedPosts.render().el)

    @appliedPostKeywordView = new Monitoring.Views.SocialContents.Filters.AppliedPostKeywordView({ searchQuery: @searchQuery })
    @$el.find('#applied_post_keyword').html(@appliedPostKeywordView.render().el)

    @appliedPostDateView = new Monitoring.Views.SocialContents.Filters.AppliedPostDateView({ searchQuery: @searchQuery })
    @$el.find('#applied_post_date').html(@appliedPostDateView.render().el)

    @appliedPostTagsView = new Monitoring.Views.SocialContents.Filters.AppliedPostTagsView({ searchQuery: @searchQuery, tagsByClientCode: @tagsByClientCode })
    @$el.find('#applied_post_tag').html(@appliedPostTagsView.render().el)

    @appliedPostLabelsView = new Monitoring.Views.SocialContents.Filters.AppliedPostLabelsView({ searchQuery: @searchQuery })
    @$el.find('#applied_post_label').html(@appliedPostLabelsView.render().el)

    @appliedPostChannelsView = new Monitoring.Views.SocialContents.Filters.AppliedPostChannelsView({ searchQuery: @searchQuery, selectedProvider: @selectedProvider })
    @$el.find('#applied_post_channel').html(@appliedPostChannelsView.render().el)

    @appliedPostSourceTypeView = new Monitoring.Views.SocialContents.Filters.AppliedPostSourceTypeView({ searchQuery: @searchQuery })
    @$el.find('#applied_post_source_type').html(@appliedPostSourceTypeView.render().el)

  destroy: ->
    @postKeywordFilterView.destroy()
    @postDateFilterView.destroy()
    @postTagsFilterView.destroy()
    @postLabelsFilterView.destroy()
    @postChannelFilterView.destroy()
    @postSourceTypeFilterView.destroy()
    @appliedPostKeywordView.destroy()
    @appliedPostDateView.destroy()
    @appliedPostTagsView.destroy()
    @appliedPostLabelsView.destroy()
    @appliedPostChannelsView.destroy()
    @appliedPostSourceTypeView.destroy()
    @remove()
    false
